import React, { useMemo, useState } from 'react';
import { ChatAvatar } from './ChatAvatar.jsx';
import { isGroupJid } from '../../../lib/sortChats';
import './UserProfilePanel.css';

// Modal para vincular el chat actual con otro (fusión en la bandeja) — integración main→dev
// (catch-up F, `d21a6bea`). Presentacional: la lista y el `onSelect`/`onClose` vienen del
// contenedor; la mutación vive en `useLinkWhatsAppChat`.
export default function WhatsLinkChatModal({ currentJid, allChats = [], onSelect, onClose, isSubmitting = false }) {
    const [search, setSearch] = useState('');

    const candidates = useMemo(() => {
        const term = search.trim().toLowerCase();
        return allChats.filter((c) => c.chat_jid !== currentJid
            && (!term || (c.name?.toLowerCase() || '').includes(term) || String(c.chat_jid).includes(term)));
    }, [allChats, currentJid, search]);

    return (
        <div className="whats-link-modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
            <div className="whats-link-modal-panel" role="dialog" aria-modal="true">
                <h3 className="whats-link-modal-title">Vincular chat</h3>
                <p className="whats-link-modal-desc">
                    Selecciona el contacto principal con el que deseas fusionar esta conversación.
                </p>
                <input
                    type="text"
                    className="whats-link-modal-search"
                    placeholder="Buscar por nombre o número..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    autoFocus
                />
                <div className="whats-link-modal-list">
                    {candidates.map((c) => (
                        <button
                            key={c.chat_jid}
                            type="button"
                            className="whats-link-modal-item"
                            disabled={isSubmitting}
                            onClick={() => onSelect(c.chat_jid)}
                        >
                            <div className="whats-link-modal-avatar">
                                <ChatAvatar url={c.avatar_url} name={c.name} jid={c.chat_jid} isGroup={isGroupJid(c.chat_jid)} />
                            </div>
                            <div className="whats-link-modal-item-text">
                                <div className="whats-link-modal-item-name">{c.name || String(c.chat_jid).split('@')[0]}</div>
                                <div className="whats-link-modal-item-jid">{c.chat_jid}</div>
                            </div>
                        </button>
                    ))}
                </div>
                <div className="whats-link-modal-actions">
                    <button type="button" className="whats-link-modal-cancel" onClick={onClose} disabled={isSubmitting}>
                        Cancelar
                    </button>
                </div>
            </div>
        </div>
    );
}
